import {
  ArrowBackIos as ArrowBackIcon,
  ArrowForwardIos as ArrowForwardIcon,
  Psychology as BrainIcon,
  Code as CodeIcon,
  PlayArrow as PlayIcon,
  Rocket as RocketIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  TrendingUp as TrendingIcon,
  Verified as VerifiedIcon,
  DashboardCustomize as WidgetIcon
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Chip,
  Container,
  Fade,
  Grid,
  IconButton,
  Paper,
  Slide,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';

// Import images
import backgroundImage from '../assets/ac.jpeg';
import bikImage from '../assets/bik.png';
import cozumImage from '../assets/cozum.webp';
import flowImage from '../assets/flow.webp';
import versiyonImage from '../assets/versiyon.png';
import Header from './Header';

const Hero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [lastManualChange, setLastManualChange] = useState(0);

  useEffect(() => {
    setIsLoaded(true);

    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const slides = [
    {
      id: 1,
      title: "Dijital Yayıncılıkta",
      subtitle: "Yeni Dönem",
      description: "Güçlü altyapı, sınırsız esneklik. Merkezinde içerik olan her şey için tek platform. React tabanlı yönetim paneli ile içeriklerinizi kolayca yönetin.",
      buttonText: "Platformu Keşfet",
      secondaryText: "Canlı Demo İzle",
      image: flowImage,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      features: ["React Tabanlı Panel", "Kolay İçerik Yönetimi", "Gelişmiş Kategori Sistemi"],
      badge: "🚀 Yeni Dönem",
      color: "#667eea",
      stats: { users: "50K+", performance: 98, satisfaction: 96 }
    },
    {
      id: 2,
      title: "Yaratıcı Atölye",
      subtitle: "İlhamınızı Özgürleştirin",
      description: "Zengin şablon kütüphanesi ve profesyonel araçlar ile hayal ettiğiniz her tasarımı görerek kolayca gerçekleştirin.",
      buttonText: "Widget Sistemini Gör",
      secondaryText: "Nasıl Çalışır?",
      image: cozumImage,
      gradient: "linear-gradient(135deg,rgb(205, 167, 14) 0%,rgb(254, 123, 0) 100%)",
      features: ["Zengin Şablon Kütüphanesi", "Profesyonel Araçlar", "Anında Kayıt"],
      badge: "🧩 Widget Sistemi",
      color: "#f59e0b",
      stats: { widgets: "100+", flexibility: 99, ease: 95 }
    },

    {
       id: 3,
      title: "Başarı Hikayeniz",
      subtitle: "Hedeflerinize Ulaşın",
      description: "Zengin şablon kütüphanesi ve profesyonel araçlar ile hayal ettiğiniz her tasarımı görerek kolayca gerçekleştirin.",
      buttonText: "Widget Sistemini Gör",
      secondaryText: "Nasıl Çalışır?",
      image: cozumImage,
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      features: ["Akıllı Analitik", "Otomatik SEO", "A/B Test Araçları"],
      badge: "🧩 Widget Sistemi",
      color: "#4facfe",
      stats: { widgets: "100+", flexibility: 99, ease: 95 }
    },
    {
      id: 4,
      title: "Next.js Gücüyle",
      subtitle: "Işık Hızında İçerik",
      description: "SSR ile yüksek performans, SEO uyumlu sayfa yapısı. Arama motorlarında üst sıralar, mobil-dostu tasarımlar.",
      buttonText: "Performansı Test Et",
      secondaryText: "SEO Raporunu Gör",
      image: versiyonImage,
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      features: ["SSR Teknolojisi", "SEO Optimizasyonu", "Mobil Uyumlu"],
      badge: "⚡ Next.js",
      color: "#fa709a",
      stats: { speed: "0.3s", seo: 100, mobile: 98 }
    },
    {
      id: 5,
      title: "Kod Bilmeden",
      subtitle: "Profesyonel Sayfa Düzeni",
      description: "Kullanıcı dostu panel ile yetkilendirme, rol bazlı erişim. Medya merkezi, zamanlanmış yayın ve otomatik kayıt özellikleri.",
      buttonText: "Paneli Deneyin",
      secondaryText: "Özellikler",
      image: bikImage,
      gradient: "linear-gradient(96deg, #0afff4 0%, #f1e107 100%)",
      features: ["Kullanıcı Dostu Panel", "Medya Merkezi", "Zamanlanmış Yayın"],
      badge: "👨‍💻 Kullanıcı Dostu",
      color: "#a8edea",
      stats: { ease: 99, features: "50+", support: 100 }
    },
    {
      id: 6,
      title: "Tasarımı Bırakın",
      subtitle: "Sadece İçeriğe Odaklanın",
      description: "Modern teknoloji, gerçek esneklik, sürdürülebilir yapı. Kontrolün sizde olduğu sistem ile teknolojiyle değil, içeriklerinizle ilgilenin.",
      buttonText: "Hemen Başlayın",
      secondaryText: "Demo Talep Et",
      image: flowImage,
      gradient: "linear-gradient(276deg, #f776ff 0%, #f2ef7a 100%)",
      features: ["Tam Kontrol", "Sürekli Geliştirme", "İnsani İletişim"],
      badge: "💎 Premium",
      color: "#ffecd2",
      stats: { control: 100, growth: 95, support: 99 }
    }
  ];

  // Handle manual navigation - pause auto-play temporarily
  const handleManualNavigation = () => {
    setIsAutoPlaying(false);
    setLastManualChange(Date.now());
  };

  // Smart navigation functions with auto-play control
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    handleManualNavigation();
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    handleManualNavigation();
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    handleManualNavigation();
  };

  // useEffect(() => {
  //   if (!isAutoPlaying) return;
  //   const timer = setInterval(() => {
  //     setCurrentSlide((prev) => (prev + 1) % slides.length);
  //   }, 4000);

  //   return () => clearInterval(timer);
  // }, [isAutoPlaying, slides.length]);

  // useEffect(() => {
  //   if (!isAutoPlaying && lastManualChange > 0) {
  //     const resumeTimer = setTimeout(() => {
  //       setIsAutoPlaying(true);
  //     }, 8000);

  //     return () => clearTimeout(resumeTimer);
  //   }
  // }, [lastManualChange, isAutoPlaying]);

  const currentSlideData = slides[currentSlide];

  const globalMetrics = [
    { icon: <SpeedIcon />, value: "99.9%", label: "Uptime", color: "#10b981", desc: "Kesintisiz Hizmet" },
    { icon: <SecurityIcon />, value: "<300ms", label: "Yükleme", color: "#f59e0b", desc: "Işık Hızı" },
    { icon: <TrendingIcon />, value: "50K+", label: "Aktif Site", color: "#6366f1", desc: "Güvenilir Platform" },
    { icon: <VerifiedIcon />, value: "A+", label: "SEO Skoru", color: "#ef4444", desc: "Arama Motoru Dostu" }
  ];

  const techHighlights = [
    { icon: <BrainIcon />, label: "React 18", color: "#61dafb", desc: "Modern UI" },
    { icon: <RocketIcon />, label: "Next.js 13", color: "#000000", desc: "SSR & SEO" },
    { icon: <WidgetIcon />, label: "Grid Layout", color: "#ff6b6b", desc: "Dinamik Tasarım" },
    { icon: <CodeIcon />, label: "TypeScript", color: "#3178c6", desc: "Tip Güvenliği" }
  ];

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: {xs:'105vh', md :'100vh'},
        background: `
          linear-gradient(
            135deg,
            rgba(0, 0, 0, 0.75) 0%,
            rgba(0, 0, 0, 0.6) 30%,
            rgba(0, 0, 0, 0.4) 50%,
            rgba(0, 0, 0, 0.6) 70%,
            rgba(0, 0, 0, 0.75) 100%
          ),
          url(${backgroundImage})
        `,
        backgroundSize: 'cover',
        backgroundPosition: `${50 + (mousePosition.x - 50) * 0.02}% ${50 + (mousePosition.y - 50) * 0.02}%`,
        backgroundAttachment: 'fixed',
        color: 'white',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        //mt: { xs: 8, md: 8 },
        transition: 'background-position 0.1s ease-out',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(99, 102, 241, 0.4) 0%, transparent 50%),
            radial-gradient(circle at ${100 - mousePosition.x}% ${100 - mousePosition.y}%, rgba(139, 92, 246, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.2) 0%, transparent 70%)
          `,
          pointerEvents: 'none',
          transition: 'background 0.3s ease'
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'url("data:image/svg+xml,%3Csvg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.02"%3E%3Cpath d="M50 50c0 13.8-11.2 25-25 25s-25-11.2-25-25 11.2-25 25-25 25 11.2 25 25zm0-50c0 13.8-11.2 25-25 25s-25-11.2-25-25 11.2-25 25-25 25 11.2 25 25z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          animation: 'float 40s linear infinite',
          pointerEvents: 'none'
        }
      }}
    >
      <Header/>
      {/* Sophisticated Geometric Elements */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: 200,
          height: 200,
          background: 'linear-gradient(45deg, rgba(99, 102, 241, 0.1), rgba(139, 92, 246, 0.1))',
          borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
          filter: 'blur(2px)',
          animation: 'morphing 20s ease-in-out infinite',
          opacity: 0.6
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '60%',
          right: '8%',
          width: 150,
          height: 150,
          background: 'linear-gradient(45deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.1))',
          borderRadius: '50%',
          filter: 'blur(1px)',
          animation: 'morphing 15s ease-in-out infinite 5s',
          opacity: 0.5
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          bottom: '20%',
          left: '10%',
          width: 120,
          height: 120,
          background: 'linear-gradient(45deg, rgba(245, 158, 11, 0.1), rgba(249, 115, 22, 0.1))',
          borderRadius: '20%',
          filter: 'blur(1.5px)',
          animation: 'morphing 12s ease-in-out infinite 10s',
          opacity: 0.4
        }}
      />

      {/* Elegant Light Rays */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            linear-gradient(45deg, transparent 0%, rgba(255, 255, 255, 0.02) 50%, transparent 100%),
            linear-gradient(-45deg, transparent 0%, rgba(255, 255, 255, 0.01) 50%, transparent 100%)
          `,
          animation: 'lightRays 30s linear infinite',
          pointerEvents: 'none'
        }}
      />

                    {/* Particle System */}
          <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 10% 20%, rgba(255, 255, 255, 0.8) 1px, transparent 1px),
              radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.6) 1px, transparent 1px),
              radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.4) 1px, transparent 1px),
              radial-gradient(circle at 90% 10%, rgba(255, 255, 255, 0.7) 1px, transparent 1px),
              radial-gradient(circle at 20% 90%, rgba(255, 255, 255, 0.5) 1px, transparent 1px)
            `,
            backgroundSize: '200px 200px, 300px 300px, 150px 150px, 250px 250px, 180px 180px',
            animation: 'float 20s ease-in-out infinite, rotate 40s linear infinite',
            opacity: 0.6,
            pointerEvents: 'none'
          }}
        />

      {/* Ultra-Premium Navigation */}
      <IconButton
        onClick={prevSlide}
        sx={{
          position: 'absolute',
          left: { xs: 20, md: 40 },
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 4,
          bgcolor: 'rgba(255,255,255,0.08)',
          backdropFilter: 'blur(40px)',
          color: 'white',
          width: 70,
          height: 70,
          border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: 3,
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          '&:hover': {
            bgcolor: 'rgba(255,255,255,0.15)',
            transform: 'translateY(-50%) scale(1.05)',
            borderColor: 'rgba(255,255,255,0.4)',
            boxShadow: '0 15px 50px rgba(0,0,0,0.4)'
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 30 }} />
      </IconButton>

      <IconButton
        onClick={nextSlide}
        sx={{
          position: 'absolute',
          right: { xs: 20, md: 40 },
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 4,
          bgcolor: 'rgba(255,255,255,0.08)',
          backdropFilter: 'blur(40px)',
          color: 'white',
          width: 70,
          height: 70,
          border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: 3,
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          '&:hover': {
            bgcolor: 'rgba(255,255,255,0.15)',
            transform: 'translateY(-50%) scale(1.05)',
            borderColor: 'rgba(255,255,255,0.4)',
            boxShadow: '0 15px 50px rgba(0,0,0,0.4)'
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        <ArrowForwardIcon sx={{ fontSize: 30 }} />
      </IconButton>

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 3 }}>
        <Grid container spacing={8} alignItems="center" sx={{ minHeight: '85vh' }}>
          {/* Content */}
          <Grid item xs={12} lg={7} >
            <Fade in={true} timeout={600} key={currentSlide}>
              <Box>
                {/* Premium Badge */}
                {/* <Slide direction="right" in={true} timeout={400}>
                  <Box sx={{ mb: 5 }}>
                    <Chip
                      label={currentSlideData.badge}
                      sx={{
                        bgcolor: 'rgba(255, 255, 255, 0.12)',
                        color: 'white',
                        fontWeight: 800,
                        fontSize: '1.2rem',
                        py: 1.5,
                        px: 4,
                        border: '1px solid rgba(255, 255, 255, 0.25)',
                        backdropFilter: 'blur(30px)',
                        borderRadius: 4,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                        transition: 'all 0.3s ease'
                      }}
                    />
                  </Box>
                </Slide> */}

                {/* Main Title */}
                <Slide direction="right" in={true} timeout={500}>
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: '3.5rem', md: '6rem', lg: '7.5rem' },
                      fontWeight: 900,
                      mb: 2,
                      background: 'linear-gradient(135deg, #ffffff 0%, #f0f9ff 30%, #e0f2fe 60%, #bae6fd 100%)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      textShadow: '0 0 80px rgba(255, 255, 255, 0.4)',
                      position: 'relative',
                      transition: 'all 0.3s ease',
                      // '&::after': {
                      //   content: '""',
                      //   position: 'absolute',
                      //   top: 0,
                      //   left: 0,
                      //   right: 0,
                      //   bottom: 0,
                      //   background: 'linear-gradient(135deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%)',
                      //   animation: 'shimmer 3s ease-in-out infinite'
                      // }
                    }}
                  >
                    {currentSlideData.title}
                  </Typography>
                </Slide>

                <Slide direction="left" in={true} timeout={600}>
                  <Typography
                    variant="h2"
                    sx={{
                      py:2,
                      fontSize: { xs: '2.8rem', md: '4.5rem', lg: '5.5rem' },
                      fontWeight: 800,
                      mb: 5,
                      background: currentSlideData.gradient,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      lineHeight: 1,
                      textShadow: '0 0 40px rgba(255, 255, 255, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {currentSlideData.subtitle}
                  </Typography>
                </Slide>

                <Fade in={true} timeout={700}>
                  <Typography
                    variant="h5"
                    sx={{
                      mb: 6,
                      opacity: 0.95,
                      fontWeight: 400,
                      lineHeight: 1.7,
                      fontSize: { xs: '1.2rem', md: '1.4rem' },
                      color: 'rgba(255, 255, 255, 0.9)',
                      maxWidth: 700,
                      letterSpacing: '0.3px',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {currentSlideData.description}
                  </Typography>
                </Fade>

                {/* Feature Highlights */}
                <Slide direction="up" in={true} timeout={800}>
                  <Grid container spacing={3} sx={{ mb: 7 }}>
                    {currentSlideData.features.map((feature, idx) => (
                      <Grid item xs={12} sm={4} key={idx}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 3,
                            bgcolor: 'rgba(255, 255, 255, 0.08)',
                            backdropFilter: 'blur(30px)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            borderRadius: 4,
                            textAlign: 'center',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                              transform: 'translateY(-8px)',
                              bgcolor: 'rgba(255, 255, 255, 0.12)',
                              borderColor: `${currentSlideData.color}40`,
                              boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
                            }
                          }}
                        >
                          <Typography variant="body1" fontWeight={700} color="white">
                            {feature}
                          </Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Slide>

                {/* Action Buttons */}
                {/* <Slide direction="up" in={true} timeout={900}>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} sx={{ mb: 8 }}>
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<RocketIcon />}
                      sx={{
                        background: currentSlideData.gradient,
                        color: 'white',
                        fontWeight: 700,
                        px: 6,
                        py: 2.5,
                        fontSize: '1.2rem',
                        borderRadius: 4,
                        textTransform: 'none',
                        boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
                        position: 'relative',
                        overflow: 'hidden',
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          top: 0,
                          left: '-100%',
                          width: '100%',
                          height: '100%',
                          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                          transition: 'left 0.6s',
                        },
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 30px 70px rgba(0,0,0,0.4)',
                          '&::before': {
                            left: '100%'
                          }
                        },
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    >
                      {currentSlideData.buttonText}
                    </Button>

                    <Button
                      variant="outlined"
                      size="large"
                      startIcon={<PlayIcon />}
                      sx={{
                        borderColor: 'rgba(255, 255, 255, 0.4)',
                        color: 'white',
                        fontWeight: 600,
                        px: 6,
                        py: 2.5,
                        fontSize: '1.2rem',
                        borderRadius: 4,
                        textTransform: 'none',
                        backdropFilter: 'blur(30px)',
                        borderWidth: 2,
                        '&:hover': {
                          borderColor: 'rgba(255, 255, 255, 0.8)',
                          bgcolor: 'rgba(255, 255, 255, 0.1)',
                          transform: 'translateY(-4px)',
                          boxShadow: '0 20px 40px rgba(255, 255, 255, 0.1)'
                        },
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    >
                      {currentSlideData.secondaryText}
                    </Button>
                  </Stack>
                </Slide> */}

                {/* Tech Stack */}
                {/* <Fade in={true} timeout={1000}>
                  <Box>
                    <Typography variant="body1" color="rgba(255,255,255,0.7)" gutterBottom fontWeight={600} sx={{ mb: 2 }}>
                      Güçlü Teknoloji Yığını:
                    </Typography>
                    <Stack direction="row" spacing={3} flexWrap="wrap" gap={2}>
                      {techHighlights.map((tech, index) => (
                        <Tooltip key={index} title={tech.desc} arrow>
                          <Paper
                            elevation={0}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              px: 3,
                              py: 1.5,
                              bgcolor: 'rgba(255, 255, 255, 0.08)',
                              backdropFilter: 'blur(20px)',
                              border: '1px solid rgba(255, 255, 255, 0.15)',
                              borderRadius: 3,
                              color: 'white',
                              fontWeight: 600,
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.12)',
                                transform: 'translateY(-2px)',
                                borderColor: 'rgba(255, 255, 255, 0.3)'
                              }
                            }}
                          >
                            {tech.icon}
                            <Typography variant="body2" fontWeight={600}>
                              {tech.label}
                            </Typography>
                          </Paper>
                        </Tooltip>
                      ))}
                    </Stack>
                  </Box>
                </Fade> */}
              </Box>
            </Fade>
          </Grid>

          {/* Image & Stats */}
          <Grid item xs={12} lg={5} className='hero-content' pt={{xs:'0px !important', md :'80px !important'}} >
            <Fade in={true} timeout={1400} key={`image-${currentSlide}`}>
              <Box
                sx={{
                  position: 'relative',
                  textAlign: 'center'
                }}
              >
                {/* Main Image with Advanced Effects */}
                <Box
                  sx={{
                    position: 'relative',
                    display: 'inline-block',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      inset: -30,
                      background: currentSlideData.gradient,
                      borderRadius: 6,
                      filter: 'blur(40px)',
                      opacity: 0.5,
                      zIndex: -1,
                      animation: 'pulse 4s ease-in-out infinite'
                    },
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      inset: -15,
                      background: 'linear-gradient(45deg, rgba(255,255,255,0.1), transparent, rgba(255,255,255,0.1))',
                      borderRadius: 6,
                      opacity: 0.6,
                      zIndex: -1,
                      animation: 'rotate 20s linear infinite'
                    }
                  }}
                >
                  <Box
                    component="img"
                    src={currentSlideData.image}
                    alt={currentSlideData.title}
                    sx={{
                      width: '100%',
                      maxWidth: { xs: 380, md: 480, lg: 600 },
                      height: 'auto',
                      borderRadius: 6,
                      boxShadow: '0 40px 100px rgba(0,0,0,0.5)',
                      border: '2px solid rgba(255, 255, 255, 0.1)',
                      transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        transform: 'scale(1.03) rotateY(5deg)',
                        boxShadow: '0 50px 120px rgba(0,0,0,0.6)'
                      }
                    }}
                  />
                </Box>

                {/* Elegant Stats Grid */}
                {/* <Grid container spacing={3} sx={{ mt: 6 }}>
                  {globalMetrics.map((metric, index) => (
                    <Grid item xs={6} md={3} lg={6} key={index}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 3,
                          textAlign: 'center',
                          bgcolor: 'rgba(255, 255, 255, 0.08)',
                          backdropFilter: 'blur(40px)',
                          border: '1px solid rgba(255, 255, 255, 0.15)',
                          borderRadius: 4,
                          transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                          '&:hover': {
                            transform: 'translateY(-8px) scale(1.02)',
                            bgcolor: 'rgba(255, 255, 255, 0.12)',
                            borderColor: `${metric.color}40`,
                            boxShadow: `0 25px 50px ${metric.color}20`
                          }
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: `${metric.color}15`,
                            color: metric.color,
                            width: 50,
                            height: 50,
                            mx: 'auto',
                            mb: 2,
                            border: `2px solid ${metric.color}30`
                          }}
                        >
                          {metric.icon}
                        </Avatar>
                        <Typography variant="h5" fontWeight={900} color="white" sx={{ mb: 0.5 }}>
                          {metric.value}
                        </Typography>
                        <Typography variant="body2" color="rgba(255,255,255,0.8)" fontWeight={600} sx={{ mb: 0.5 }}>
                          {metric.label}
                        </Typography>
                        <Typography variant="caption" color="rgba(255,255,255,0.6)" fontWeight={500}>
                          {metric.desc}
                        </Typography>
                      </Paper>
                    </Grid>
                  ))}
                </Grid> */}
              </Box>
            </Fade>
          </Grid>
        </Grid>
      </Container>

      {/* Ultra-Premium Slide Indicators */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 50,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 3,
          zIndex: 4
        }}
      >
        {slides.map((slide, index) => (
          <Tooltip key={index} title={slide.title} arrow>
            <Box
              onClick={() => goToSlide(index)}
              sx={{
                width: currentSlide === index ? 60 : 20,
                height: 20,
                borderRadius: 10,
                bgcolor: currentSlide === index ? 'white' : 'rgba(255,255,255,0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.2)',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: currentSlide === index ? '0 10px 30px rgba(255,255,255,0.3)' : 'none',
                '&:hover': {
                  bgcolor: currentSlide === index ? 'white' : 'rgba(255,255,255,0.6)',
                  transform: 'scale(1.2)',
                  boxShadow: '0 10px 30px rgba(255,255,255,0.3)'
                },
                '&::before': currentSlide === index ? {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: slide.gradient,
                  opacity: 0.8
                } : {}
              }}
            />
          </Tooltip>
        ))}
      </Box>

      <style jsx global>{`
        @keyframes morphing {
          0%, 100% {
            border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            border-radius: 58% 42% 75% 25% / 76% 46% 54% 24%;
            transform: translate(10px, -10px) rotate(90deg);
          }
          50% {
            border-radius: 50% 50% 33% 67% / 55% 27% 73% 45%;
            transform: translate(-5px, 5px) rotate(180deg);
          }
          75% {
            border-radius: 33% 67% 58% 42% / 63% 68% 32% 37%;
            transform: translate(-10px, -5px) rotate(270deg);
          }
        }

        @keyframes lightRays {
          0% { transform: translateX(-100%) rotate(0deg); }
          100% { transform: translateX(100%) rotate(360deg); }
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.05); }
        }

        @keyframes rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </Box>
  );
};

export default Hero;